import React, { Component } from 'react';
import { Link, browserHistory } from 'react-router';
import MediaList from '../components/MediaListComponent';
// import UserList from '../components/UserListComponent';
// import Loading from '../components/LoadingComponent';
import SearchActions from '../actions/SearchActions';
import SearchStore from '../stores/SearchStore';

require('./SearchWrap.scss');
require('./Search.scss');

class SearchComponent extends Component{
  constructor(props) {
    super(props);
    let searchStore = SearchStore.getState();
    this.state = {
      tab: searchStore.tab,
      keyword: searchStore.keyword,
      products: searchStore.products,
      albums: searchStore.albums,
      medias: searchStore.medias,
      features: searchStore.features,
      users: searchStore.users,
      // loading: searchStore.loading,
      // hasMore: searchStore.hasMore
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.changeTab = this.changeTab.bind(this);
    this.searchContent = this.searchContent.bind(this);
    this.onSearchChange = this.onSearchChange.bind(this);
  }

  componentDidMount(){
    SearchStore.listen(this.onSearchChange);
    this.searchContent();

    let searchStore = SearchStore.getState();
    window.scroll(0,searchStore.height);
  }

  componentWillUnmount(){
    SearchStore.unlisten(this.onSearchChange);
    SearchActions.updateKeyword(this.state.keyword);
    SearchActions.updateHeight(this.state.tab,$(document).scrollTop())
  }

  handleChange(event) {
    let state = {};
    state[event.target.name] = event.target.value;
    this.setState(state);
  }

  changeTab(tab){
    this.setState({tab})
    this.state.tab = tab;
    window.scroll(0,0);
    SearchActions.clearData('all');
    this.searchContent();
  }

  handleSubmit(e) {
    e.preventDefault();
    if(this.state.keyword){
      window.scroll(0,0);
      SearchActions.clearData('all');
      this.searchContent();
    }else{
      alert('请输入检索内容！');
    }
  }

  searchContent(){
    let {tab, keyword} = this.state;
    if(tab == 1){
      SearchActions.fetchProducts(keyword);
    }else if(tab == 2){
      SearchActions.fetchAlbums(keyword);
    }else if(tab == 3){
      SearchActions.fetchMedias(keyword);
    }else if(tab == 4){
      SearchActions.fetchFeatures(keyword);
    }else if(tab == 5){
      SearchActions.fetchUsers(keyword);
    }
  }
  
  onSearchChange(state){
    this.setState({
      // loading: state.loading,
      // hasMore: state.hasMore,
      products: state.products,
      albums: state.albums,
      medias: state.medias,
      features: state.features,
      users: state.users
    })
  }

  render(){
    let lists;
    let {tab} = this.state;
    if(tab == 1){
      lists = this.state.products.map((product) => {
        return <Link key={product._id} to={`/route/${product._id}`} className="product">
          <div className="cover"><img src={product.cover.small} /></div>
          <div className="title">{product.title}</div>
        </Link>;
      })
    }else if(tab == 2){
      lists = this.state.albums.map((album) => {
        return <Link key={album._id} to={`/article/${album._id}`} className="album">
          <div className="cover"><img src={album.media.images.small[0]} /></div>
          <div className="title">{album.name}</div>
        </Link>;
      })
    }else if(tab == 3){
      lists = <MediaList medias={this.state.medias} loading={true} />
    }else if(tab == 4){
      lists = this.state.features.map((feature) => {
        return <Link key={feature._id} to={`/feature/${feature._id}?type=feature&name=${feature.name}`} className="feature">
          #{feature.name}
        </Link>;
      })
    } 
    // }else if(tab == 5){
    //   lists = <UserList users={this.state.users} loading={this.state.loading} />
    // }
    return <div className="search-component">
      <div className="search-input-wrap">
        <button className="cancel" onClick={() =>{ this.setState({keyword: ''});browserHistory.goBack();} }>取消</button>
        <form action="" onSubmit={this.handleSubmit}>
          <input className="search-input" autoComplete="off" type="search" name="keyword" value={this.state.keyword} onChange={this.handleChange} placeholder="搜索" autoFocus/>
        </form>
      </div>
      <div className="menu-wrap">
        <a href="javascript:void(0)" onClick={this.changeTab.bind(this,4)} className={this.state.tab == 4?'menu active':'menu'}>特色</a>
        <a href="javascript:void(0)" onClick={this.changeTab.bind(this,1)} className={this.state.tab == 1?'menu active':'menu'}>行程</a>
        <a href="javascript:void(0)" onClick={this.changeTab.bind(this,2)} className={this.state.tab == 2?'menu active':'menu'}>美文</a>
        <a href="javascript:void(0)" onClick={this.changeTab.bind(this,3)} className={this.state.tab == 3?'menu active':'menu'}>单点</a>
        {/* <a href="javascript:void(0)" onClick={this.changeTab.bind(this,5)} className={this.state.tab == 5?'menu active':'menu'}>用户</a> */}
      </div>
      <div className="content-wrap">
        {lists}
      </div>
      {/* <Loading loading={this.state.loading} hasMore={this.state.hasMore} /> */}
    </div>
  }
}

export default SearchComponent;


// WEBPACK FOOTER //
// ./src/develop/SearchComponent.js